"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Popover =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(Popover, _Backbone$View);

  function Popover(opts) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).apply(this, arguments));

    if (!opts.target) {
      throw new Error('you must specify a target');
    }

    _this.contents = opts.contents;
    _this.target = opts.target;
    _this.enabled = false;
    _this.requestedWidth = opts.width || 300;

    _this.target.on('click', function (e) {
      _this.toggle();

      e.stopPropagation();
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "getParams",
    value: function getParams() {
      var topMargin = 6;
      var sideMargin = 5;
      var caretSpacer = 4;
      var targetOffset = this.target.offset();
      var targetWidth = this.target.width();
      targetOffset.right = targetOffset.left + targetWidth;
      var targetHeight = this.target.height();
      var viewportWidth = $(window).width();
      var viewportHeight = $(window).height();
      var width = Math.min(this.requestedWidth - 2 * sideMargin, viewportWidth);
      var xOverlap = width - targetWidth;
      var spaceToLeft = targetOffset.left;
      var spaceToRight = viewportWidth - targetOffset.right;
      var leftHasRoom = spaceToLeft >= xOverlap / 2;
      var rightHasRoom = spaceToRight >= xOverlap / 2; // prefer centering on the target.  This is different than the foundation popovers but much easier to reason about.

      var left, right, top, bottom, caretLeft, caretRight, alignmentClass;

      if (leftHasRoom && rightHasRoom) {
        // horizontally centered on the target element
        left = targetOffset.left - xOverlap / 2;
        right = viewportWidth - targetOffset.right - xOverlap / 2;
        caretLeft = width / 2;
        alignmentClass = 'popoverCenter';
      } else if (spaceToRight >= xOverlap) {
        // align the left edge to the target's left edge
        left = targetOffset.left;
        right = viewportWidth - targetOffset.right - xOverlap;
        caretLeft = caretSpacer;
        alignmentClass = 'popoverLeft';
      } else if (spaceToLeft >= xOverlap) {
        // align the right edge to the target's right edge
        left = targetOffset.left - xOverlap;
        right = viewportWidth - targetOffset.right;
        caretRight = caretSpacer;
        alignmentClass = 'popoverRight';
      } else {
        // the viewport is narrower than the desired popover width. Fill the available space.
        left = 0;
        right = 0;
        caretLeft = targetOffset.left + targetWidth / 2;
        alignmentClass = 'popoverFit';
      }

      var openUp = (this.target[0].getBoundingClientRect().top + targetHeight / 2) / viewportHeight > 0.666666;

      if (!openUp) {
        top = targetOffset.top + topMargin + targetHeight;
      } else {
        bottom = viewportHeight - targetOffset.top + topMargin;
      }

      return {
        main: {
          top: top,
          bottom: bottom,
          left: left,
          right: right
        },
        caret: {
          left: caretLeft,
          right: caretRight
        },
        directionClass: openUp ? 'popoverUp' : 'popoverDown',
        alignmentClass: alignmentClass
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var params = this.getParams();
      this.$el.empty();
      this.$el = $("\n            <div class=\"popoverCanvas ".concat(params.directionClass, " ").concat(params.alignmentClass, "\">\n                <div class=\"popover\" style=\"\n                    ").concat(params.main.top ? "top:".concat(params.main.top, "px;") : '', "\n                    ").concat(params.main.bottom ? "bottom:".concat(params.main.bottom, "px;") : '', "\n                    left:").concat(params.main.left, "px;\n                    right:").concat(params.main.right, "px\"\n                    aria-live=\"polite\">\n                        <div class=\"popoverCaret\" style=\"\n                                ").concat(params.caret.right ? "right:".concat(params.caret.right, "px;") : '', "\n                                ").concat(params.caret.left ? "left:".concat(params.caret.left, "px;") : '', "\" >\n                            <div class=\"popoverCaretTip\"></div>\n                        </div>\n                        ").concat(this.contents, "\n                </div>\n            </div>\n        "));
      $('body').append(this.$el);
      $('body').click(function () {
        return _this2.hide();
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$el.remove();
      this.enabled = false;
    }
  }, {
    key: "show",
    value: function show() {
      this.render();
      this.enabled = true;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.enabled) {
        this.hide();
      } else {
        this.show();
      }
    }
  }]);

  return Popover;
}(Backbone.View);

exports["default"] = Popover;